<template>
  <v-container fluid class="px-0">
    <div class="gl-post-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="rhead">
                    {{ initvalue.posttype }} {{ initvalue.postnum }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col md="1" align="right">
                      <v-btn
                      class="button-shadow"
                      color="primary"
                     @click="Done"
                      >
                        Done
                      </v-btn>
                </v-col>
              </v-row>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Num</td>
                        <td>{{ initvalue.postnum }}</td>
                      </tr>

                      <tr>
                        <td class="thead">Name</td>
                        <td>{{ initvalue.postname }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Date</td>
                        <td>{{ new Date(initvalue.postdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Period</td>
                        <td>{{ new Date(initvalue.poststartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }} - {{ new Date(initvalue.postenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Note</td>
                        <td class="tcell">{{ initvalue.postnote }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-items'"
                    >
                      Transactions
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-items'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            :footer-props="footer"
                            :headers="itemHeaders2"
                            :items="transactions"
                            :items-per-page="itemPerPage"
                          >
                          <template v-slot:item.accountid="{ item }">
                              <div v-if="item.accountid">
                                {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountnum'] : '' }}
                                :
                                {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                              </div>
                            </template>
                            <template v-slot:item.transdate="{ item }">
                              {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                            </template>
                            <template v-slot:item.creditAmount="{ item }">
                              <p class="two-line">{{ item.creditAmount.toFixed(2) }}</p>
                            </template>
                            <template v-slot:item.debitAmount="{ item }">
                              <p class="two-line">{{ item.debitAmount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapState, mapActions } from 'vuex'

export default {
  name: "Profile",

  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      selectedTab: "1",
      showImageDialog: false,
      image: null,
      itemHeaders2: [
        { text: 'Date', value: 'transdate', width: '8%' },  
        { text: 'Type', value: 'transtype', width: '8%'},
        { text: 'Description', value: 'transdesc',},
        { text: 'Account', value: 'accountid', width: '20%' },
        { text: 'Credit', value: 'creditAmount', width: '10%'},
        { text: 'Debit', value: 'debitAmount', width: '10%'},
      ],

      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions("File", ["getGLPostFiles"]),
    clickImage(image){
      console.log(image.imageurl);
      this.image = image;
      this.showImageDialog = true;
    },
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.fileurl;
      params.isFromGLPost = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
    Done(){
      this.$router.push({ name: 'GLPostList' });
    },
    insertTransactionsSum(){
      let credit = this.transactions.reduce((a,b)=>a + (b.creditAmount) , 0);
      let debit = this.transactions.reduce((a,b)=>a + (b.debitAmount) , 0);
      this.transactions.push({accountid: null, creditAmount: credit, debitAmount: debit })
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "GLPostList" });
    this.transactions = Object.assign([],this.initvalue.transactions);
    this.insertTransactionsSum();
    if(this.accounts.length==0) await this.getAccountsRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
